import {useEffect, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {doc} from "prettier";
import label = doc.builders.label;

export type AvailableDriverTypes = {
    sms: boolean;
    call: boolean;
    email: boolean;
    app: boolean;
};

const ALL_ENABLED: AvailableDriverTypes = {sms: true, call: true, email: true, app: true};

export function useAvailableDriverTypes(clientID: string | null | undefined): AvailableDriverTypes {
    const [types, setTypes] = useState<AvailableDriverTypes>(ALL_ENABLED);

    useEffect(() => {
        if (!clientID) {
            setTypes(ALL_ENABLED);
            return;
        }
        platformAPI.get<AvailableDriverTypes>(`api/siren/available-driver-types?clientID=${clientID}`)
            .then(res => setTypes(res.data))
            .catch(() => setTypes(ALL_ENABLED));
    }, [clientID]);

    return types;
}

export function filterMethodsByDriverTypes(
    options: {value: string; label: string}[],
    types: AvailableDriverTypes,
): {value: string; label: string}[] {
    return options.filter(o => {

        if (o.value.startsWith("sms_")) return types.sms;
        if (o.value.startsWith("email_")) return types.email;
        if (o.value.startsWith("call_")) return types.call;
        if (o.value.includes("app")) return types.app;
        return true;
    });
}
